import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Input,
  Modal,
  Popconfirm,
  Select,
  Space,
  Table,
  Tag,
  Typography,
  message,
  Card,
} from 'antd';
import { Option } from 'antd/lib/mentions';
import Column from 'antd/lib/table/Column';
import ColumnGroup from 'antd/lib/table/ColumnGroup';
import axios from 'axios';
import { getFilterFromJira } from 'components/skills/skills_action';
import React, { useEffect, useState } from 'react';

const AppHomeFilterV2 = (props) => {
  // props
  const {
    setSelectedFilterFromJira,
    selectedFilterFromJira,
    setPreBuiltFilter,
    preBuiltFilter,
    jqlFilter,
    setJqlFilter,
    filterType,
    setFilterType,
    IssuesPerPagesetIssuesPerPage,
    appHomeInfo,
    updateNow,
    setUpdateNow,
    defaultFilterName,
    setDefaultFilterName,
    setDefaultFilterKey,
    defaultFilterKey,
    isPersonalApphome,
  } = props;
  const { Text, Title } = Typography;

  // jql common filter states
  const [commonJqlFilter, setCommonJqlFilter] = useState([]);
  const [isJqlFilterModalVisible, setIsJqlFilterModalVisible] = useState(false);
  const [commonJqlFilterName, setCommonJqlFilterName] = useState('');
  const [commonJqlFilterExp, setCommonJqlFilterExp] = useState('');
  const [commonJqlFilterModalStatus, setCommonJqlFilterModalStatus] =
    useState('');
  const [commonJqlFilterId, setCommonJqlFilterId] = useState('');
  const [isCommonJqlFilterActionDisabled, setIsCommonJqlFilterActionDisabled] =
    useState(false);
  const [allFilters, setAllFilters] = useState([
    {
      key: '1',
      filterName: 'Assigned to Me',
      value: 'assigned_to_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '2',
      filterName: 'Reported by me',
      value: 'reported_by_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '3',
      filterName: 'Watched by me',
      value: 'watched_by_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '4',
      filterName: 'All Open',
      value: 'not_done_issues',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
  ]);
  const preBuiltFilters = [
    {
      key: '1',
      filterName: 'Assigned to Me',
      value: 'assigned_to_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '2',
      filterName: 'Reported by me',
      value: 'reported_by_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '3',
      filterName: 'Watched by me',
      value: 'watched_by_me',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
    {
      key: '4',
      filterName: 'All Open',
      value: 'not_done_issues',
      isDefault: false,
      type: 'prebuiltfilter',
      tags: ['prebuilt'],
      jqlQuery: '',
    },
  ];
  const pageSizeOptions = ['5', '10', '20'];

  const paginationConfig = {
    showSizeChanger: true,
    pageSizeOptions: pageSizeOptions,
    defaultPageSize: parseInt(pageSizeOptions[0]),
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    // You can add more customization here as needed
  };

  // function for table loading
  const getAllFilters = async () => {
    let commonFilters = await fetchCommonFilters();
    let jiraFilters = await getJiraFilters();

    let updatedArrayFilters = allFilters.concat(commonFilters, jiraFilters);
    let defaultUpdatedFilters = await setDefaultFilterInTable(
      updatedArrayFilters
    );

    // in rare cases the elements comes as undefined to avoid any error
    if (defaultUpdatedFilters[0]) {
      setAllFilters(defaultUpdatedFilters);
    } else {
      setAllFilters(updatedArrayFilters);
    }
  };

  const getJiraFilters = async () => {
    const workspaceid = localStorage.getItem('userCurrentWorkspaceId');
    let jiraFilters = await getFilterFromJira(workspaceid);
    if (jiraFilters.data.success) {
      return convertJiraFiltersAndMergeIntoExistingOne(jiraFilters.data.items);
    }
    return [];
  };

  const fetchCommonFilters = async () => {
    const workspaceid = localStorage.getItem('userCurrentWorkspaceId');

    try {
      const jqlFilter = await axios.get(
        `/bot/api/w/${workspaceid}/jira/jqlfilter`
      );
      return ConvertJQLCommonFiltersAndMergeIntoExistingOne(
        jqlFilter && jqlFilter.data.data[0].filters
      );
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const ConvertJQLCommonFiltersAndMergeIntoExistingOne = (originalArray) => {
    const convertedArray =
      originalArray &&
      originalArray.map((item) => {
        return {
          key: item._id,
          filterName: item.filterName,
          tags: ['Custom JQL'],
          isDefault: false,
          type: 'jqlfilter',
          jqlQuery: item.jqlFilter,
        };
      });
    return convertedArray;
  };

  const convertJiraFiltersAndMergeIntoExistingOne = (originalArray) => {
    const convertedArray =
      originalArray &&
      originalArray.map((item) => {
        return {
          key: item.id,
          filterName: item.name,
          tags: ['Jira Filters'],
          isDefault: false,
          type: 'filterfromjira',
          jqlQuery: item.jql,
        };
      });

    return convertedArray;
  };

  // common filters functions

  const fetchJqlFilter = async () => {
    const workspaceid = localStorage.getItem('userCurrentWorkspaceId');

    try {
      const jqlFilter = await axios.get(
        `/bot/api/w/${workspaceid}/jira/jqlfilter`
      );
      if (!!jqlFilter.data.success) {
        setCommonJqlFilter(jqlFilter.data.data[0].filters);
      }
    } catch (error) {
      console.error('see this error===>', JSON.stringify(error));
    }
  };
  const toggleJqlFilterModal = () => {
    setIsJqlFilterModalVisible((prevState) => !prevState);

    if (!isJqlFilterModalVisible) {
      setCommonJqlFilterName('');
      setCommonJqlFilterExp('');
      setCommonJqlFilterId('');
    }
  };

  const openJqlFilterModal = (filter) => {
    if (filter != null) {
      toggleJqlFilterModal();
      setCommonJqlFilterName(filter.filterName);
      setCommonJqlFilterExp(filter.jqlQuery);
      setCommonJqlFilterId(filter.key);

      setCommonJqlFilterModalStatus('UPDATE');
    } else {
      setCommonJqlFilterModalStatus('ADD');
      toggleJqlFilterModal();
    }
  };

  const addJqlFilter = () => {
    if (commonJqlFilterName.trim() != '' && commonJqlFilterExp.trim() != '') {
      let isUsed =
        commonJqlFilter &&
        commonJqlFilter.find((el) => el.filterName === commonJqlFilterName);
      if (isUsed) {
        if (
          commonJqlFilterModalStatus === 'UPDATE' &&
          commonJqlFilterId === (isUsed && isUsed._id)
        ) {
        } else {
          return message.error(
            'Jql Filter name is already used, Please use different name.'
          );
        }
      }

      if (commonJqlFilterModalStatus === 'ADD') {
        jqlFilterOps({
          filterName: commonJqlFilterName,
          jqlFilter: commonJqlFilterExp,
          filterId: null,
        });
      }
      if (commonJqlFilterModalStatus === 'UPDATE') {
        if (commonJqlFilterId.trim() != '') {
          jqlFilterOps({
            filterId: commonJqlFilterId,
            filterName: commonJqlFilterName,
            jqlFilter: commonJqlFilterExp,
          });
        } else {
          message.error('jql filter id missing');
        }
      }
    } else {
      message.warn('Please fill all details');
    }
  };

  const jqlFilterOps = async ({ filterName, jqlFilter, filterId }) => {
    setIsCommonJqlFilterActionDisabled(true);

    const wsid = localStorage.getItem('userCurrentWorkspaceId');

    const body = {
      workspaceId: wsid,
      filterName,
      jqlFilter,
      filterId,
    };

    try {
      const jqlFilterResp = await axios.post(
        `/bot/api/w/${wsid}/jira/jqlfilter`,
        body
      );
      let tempFilter = {
        key: filterId ? filterId : '123',
        filterName: filterName,
        tags: ['Custom JQL'],
        isDefault: false,
        type: 'jqlfilter',
        jqlQuery: jqlFilter,
      };

      if (filterId) {
        let wasUpdatedDefault = allFilters.find(
          (filter) => filter.key == filterId
        ).isDefault;
        setAllFilters((prevFilters) => {
          const updatedFilters = [...prevFilters];
          const indexToUpdate = updatedFilters.findIndex(
            (f) => f.key === tempFilter.key
          );
          if (wasUpdatedDefault) {
            tempFilter.isDefault = true;
          }
          if (indexToUpdate !== -1) {
            updatedFilters[indexToUpdate] = { ...tempFilter };
          } else {
            updatedFilters.push({ ...tempFilter });
          }
          return [...updatedFilters];
        });
        if (wasUpdatedDefault) {
          setDeafultFilter(tempFilter);
        }
      }

      setIsCommonJqlFilterActionDisabled(false);
      if (!!jqlFilterResp.data.success) {
        message.success(jqlFilterResp.data.message);
        if (!filterId) {
          updateFiltersOnNewFilterAddition();
          // updateFiltersArrayTemp(tempFilter);
        }

        toggleJqlFilterModal();
      } else {
        message.error(jqlFilterResp.data.message);
      }

      // getAllFilters();
    } catch (error) {
      setIsCommonJqlFilterActionDisabled(false);
      message.error('Something went wrong! Please try again later');
    }
  };

  const updateFiltersOnNewFilterAddition = async () => {
    let commonFilters = await fetchCommonFilters();
    let jiraFilters = await getJiraFilters();

    let updatedArrayFilters = preBuiltFilters.concat(
      commonFilters,
      jiraFilters
    );
    let defaultUpdatedFilters = await setDefaultFilterInTable(
      updatedArrayFilters
    );

    setAllFilters([]);
    setAllFilters((prevFilters) => [...defaultUpdatedFilters]);
  };

  const updateFiltersArrayTemp = (filter) => {
    setAllFilters((prevFilters) => [...prevFilters, filter]);
  };

  function removeObjectByKey(array, key) {
    return array.filter((item) => item.key !== key);
  }

  const removeJqlFilter = async () => {
    const workspaceid = localStorage.getItem('userCurrentWorkspaceId');

    const filterId = commonJqlFilterId;

    try {
      const jqlFilter = await axios.delete(
        `/bot/api/w/${workspaceid}/jira/jqlfilter/${filterId}`
      );
      if (!!jqlFilter.data.success) {
        message.success(jqlFilter.data.message);
        toggleJqlFilterModal();
        // fetchJqlFilter();
        let wasDeletedDefault = allFilters.find(
          (filter) => filter.key == filterId
        ).isDefault;
        let updatedFiltersArray = removeObjectByKey(allFilters, filterId);
        if (wasDeletedDefault) {
          setDeafultFilter({
            key: '1',
            filterName: 'Assigned to Me',
            value: 'assigned_to_me',
            isDefault: false,
            type: 'prebuiltfilter',
            tags: ['prebuilt'],
            jqlQuery: '',
          });
          updatedFiltersArray[0].isDefault = true;
        }
        setAllFilters(updatedFiltersArray);
      } else {
        message.error(jqlFilter.data.message);
      }
    } catch (error) {
      message.error('Something went wrong! Please try again later');
    }
  };

  // function to set Defaults

  const makeCertainFilterDefault = (key) => {
    let updatedFilters = allFilters.map((filter) => {
      if (filter.isDefault && filter.key !== key) {
        return { ...filter, isDefault: false };
      }
      if (filter.key == key) {
        return { ...filter, isDefault: true };
      }
      return filter;
    });
    setAllFilters(updatedFilters);
  };

  const setDeafultFilter = (filter) => {
    if (filter.type === 'prebuiltfilter') {
      setFilterType(filter.type);
      setPreBuiltFilter(filter.value);
      // to show default
      makeCertainFilterDefault(filter.key);
      setUpdateNow(true);
    } else if (filter.type === 'jqlfilter') {
      setFilterType(filter.type);
      setJqlFilter(filter.jqlQuery);
      setDefaultFilterKey(filter.key);
      setDefaultFilterName(filter.filterName);
      makeCertainFilterDefault(filter.key);
      setUpdateNow(true);
    } else if (filter.type === 'filterfromjira') {
      setFilterType('filterfromjira');
      setSelectedFilterFromJira(filter.jqlQuery);
      setDefaultFilterKey(filter.key);
      setDefaultFilterName(filter.filterName);
      makeCertainFilterDefault(filter.key);
      setUpdateNow(true);
    }
  };

  // function to show which filter is default one

  const setDefaultFilterInTable = async (originalFiltersArray) => {
    const page =
      appHomeInfo &&
      appHomeInfo.pages &&
      appHomeInfo.pages.find((page) => page._id === props.appHomeInfo.pageView);
    let filterType = page && page.customizeConfiguration.filterType;
    let prebuiltFilterValue =
      page && page.customizeConfiguration.preBuiltFilter;
    let jqlFilter = page && page.customizeConfiguration.jqlFilter;
    let jiraJqlFilter =
      page && page.customizeConfiguration.selectedFilterFromJira;
    let defaultFilterName =
      page && page.customizeConfiguration.defaultFilterName;
    let deafultFilterKey = page && page.customizeConfiguration.defaultFilterKey;
    let updatedFiltersArray = originalFiltersArray.map((filter) => {
      if (filterType === 'prebuiltfilter') {
        if (filter.value === prebuiltFilterValue) {
          return { ...filter, isDefault: true };
        }
        return filter;
      } else if (filterType == 'jqlfilter') {
        if (
          filter.jqlQuery === jqlFilter &&
          filter.filterName === defaultFilterName &&
          filter.key === deafultFilterKey
        ) {
          return { ...filter, isDefault: true };
        }
        return filter;
      } else if (filterType == 'filterfromjira') {
        if (filter.jqlQuery == jiraJqlFilter) {
          return { ...filter, isDefault: true };
        }
        return filter;
      }
    });

    return updatedFiltersArray;
  };

  useEffect(() => {
    getAllFilters();
  }, []);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '500px',
          overflowY: 'scroll',
          paddingBottom: '100px',
        }}
      >
        <Modal
          title='Custom JQL'
          visible={isJqlFilterModalVisible}
          onCancel={toggleJqlFilterModal}
          onOk={addJqlFilter}
          okText={commonJqlFilterModalStatus === 'ADD' ? 'Create' : 'Update'}
          footer={[
            <Button
              onClick={toggleJqlFilterModal}
              key='back'
              style={{
                marginRight: 15,
              }}
            >
              Cancel
            </Button>,
            <Popconfirm
              placement='top'
              title={`Are you sure to delete this filter?`}
              onConfirm={removeJqlFilter}
              okText='Yes'
              cancelText='No'
            >
              <Button
                type='danger'
                disabled={commonJqlFilterModalStatus === 'ADD'}
                key='delete'
                hidden={commonJqlFilterModalStatus === 'ADD'}
                style={{
                  marginRight: 15,
                }}
              >
                Delete
              </Button>
            </Popconfirm>,
            <Button
              type='primary'
              onClick={addJqlFilter}
              disabled={isCommonJqlFilterActionDisabled}
              key='submit'
            >
              {commonJqlFilterModalStatus === 'ADD' ? 'Create' : 'Update'}
            </Button>,
          ]}
        >
          <Text>Name (max 20 chars)</Text>
          <br />
          <Input
            label='Name'
            defaultValue={commonJqlFilterName}
            value={commonJqlFilterName}
            maxLength={20}
            onChange={(e) => setCommonJqlFilterName(e.target.value)}
          />
          <br />
          <br />
          <Text>Filter (JQL)</Text>
          <br />
          <Input
            label='Filter'
            defaultValue={commonJqlFilterExp}
            value={commonJqlFilterExp}
            onChange={(e) => setCommonJqlFilterExp(e.target.value)}
          />
        </Modal>
        <Card
          title='Filters'
          extra={
            <>
              {!isPersonalApphome && (
                <Button
                  style={{
                    marginBottom: 15,
                    justifySelf: 'flex-end',
                    maxWidth: 100,
                  }}
                  onClick={() => {
                    openJqlFilterModal(null);
                  }}
                  icon={<PlusOutlined />}
                >
                  Filter
                </Button>
              )}
            </>
          }
        >
          <Table
            scroll={{
              y: 300,
            }}
            rowKey={(record) => record.key}
            dataSource={allFilters}
            pagination={paginationConfig}
            fixed={'top'}
          >
            <Column
              title='Name'
              dataIndex='filterName'
              key='filterName'
              render={(text, record) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '10px' }}>{text}</span>
                  {record.isDefault && <Tag color='green'>Default</Tag>}
                </div>
              )}
            />
            <Column
              title='Type'
              dataIndex='tags'
              key='tags'
              render={(tags) => (
                <>
                  {tags &&
                    tags.map((tag) => (
                      <Tag color='blue' key={tag}>
                        {tag}
                      </Tag>
                    ))}
                </>
              )}
            />
            <Column
              title='Action'
              key='action'
              render={(_, record) => (
                <Space size='middle'>
                  {!record.isDefault && (
                    <a onClick={() => setDeafultFilter(record)}>Set Default</a>
                  )}
                  {record.type === 'jqlfilter' && !isPersonalApphome && (
                    <a onClick={() => openJqlFilterModal(record)}>Update</a>
                  )}
                </Space>
              )}
            />
          </Table>
        </Card>
      </div>
    </>
  );
};

export default AppHomeFilterV2;
